module.exports = __webpack_public_path__ + "img/plane.190f1b3b.jpg";